import Vue from 'vue'
import App from './App.vue'

import './assets/common.less'

import dataV from '@jiaminghi/data-view'
import axios from 'axios'

Vue.config.productionTip = false

Vue.use(dataV)
Vue.prototype.$http = axios

new Vue({
  render: h => h(App)
}).$mount('#app')
